import { app } from '../../../../app';

class RemoteAppAccessService {

    /** @ngInject */
    constructor($http) {
        this.$http = $http;
        
    }

    constructUrl (companyId, appId, remoteAppId) {
    	var url=`app/rest/admin/company/${companyId}/application/${appId}/sraapps`;
        if(remoteAppId !== null) {
        	url=url+`/${remoteAppId}`;
        }
        return url;
    }
    list(companyId, appId) {
    	const url =this.constructUrl(companyId,appId,null);
        return this.$http.get(url).then(({data}) => data);
    }

    remove(companyId, appId, remoteAppId) {
    	const url =this.constructUrl(companyId,appId,remoteAppId);
        return this.$http.delete(url).then(({data}) => data);
    }

    save(companyId, appId, remoteApp) {
    	const url =this.constructUrl(companyId,appId,null);
        return this.$http.post(url, remoteApp).then(({data}) => data);
    }

  
}

app.service('RemoteAppAccessService', RemoteAppAccessService);



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/remote-app-access/remote-app-access.service.js